<mat-button-toggle-group class="st-live-main-cta-button-group">
    <mat-button-toggle
        class="st-live-main-cta-button-new-rundown"
        [class.st-live-main-cta-button-new-rundown__disabled]="!rundownEditable()"
        [disabled]="!rundownEditable()"
        (click)="selectRundownTemplateOrNew()">
        <mat-icon class="material-symbols-outlined">add</mat-icon>
        {{ languageSettings.PSTWebNewRundownLabel }}
    </mat-button-toggle>
    <mat-button-toggle
        mat-icon-button
        class="st-live-main-cta-button-new-rundown-template"
        [class.st-live-main-cta-button-new-rundown-template__disabled]="!rundownEditable()"
        [matMenuTriggerFor]="feedTemplateMenu"
        [disabled]="!rundownEditable() || !rundownTemplates()?.length"
        (menuOpened)="onRundownTemplateMenuOpened()">
        <mat-icon>arrow_drop_down</mat-icon>
    </mat-button-toggle>
</mat-button-toggle-group>

<mat-menu
    #feedTemplateMenu="matMenu"
    class="st-live-main-cta-templates-menu">
    @if (rundownTemplates().length > 0) {
        <ng-template matMenuContent>
            @for (item of rundownTemplates(); track item?.Guid) {
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false">
                    <mat-list-option
                        [value]="item?.Title"
                        [disabled]="item?.isDeleted"
                        (click)="selectRundownTemplateOrNew(item)">
                        <div
                            matListItemTitle
                            class="st-live-main-cta-button-new-rundown-template__title">
                            <span>{{ item?.Title }}</span>
                            @if (item?.Guid !== optionBlank) {
                                <button
                                    mat-icon-button
                                    matListItemMeta
                                    st-click-stop-propagation
                                    [disabled]="item?.isDeleted"
                                    (click)="deleteTemplate(item)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            }
                        </div>
                    </mat-list-option>
                </mat-selection-list>
            }
        </ng-template>
    }
</mat-menu>
